import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { UserdataService } from 'src/app/services/userdata.service';

@Component({
  selector: 'app-view-vumatel-network-events',
  templateUrl: './view-vumatel-network-events.component.html',
  styleUrls: ['./view-vumatel-network-events.component.scss']
})
export class ViewVumatelNetworkEventsComponent implements OnInit {
  form: FormGroup
  paramsid: number;
  displayedColumns: string[] = [
    'Name',
    'Surname',
    'Phonenumber',
    'Email',
    'NetworkIdentifier',
];
@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
@ViewChild(MatSort, { static: true }) sort: MatSort;
data: any = []
dataSource = new MatTableDataSource(this.data);
  value: any;
  constructor(
    private formBuilder: FormBuilder,
    private activateroute: ActivatedRoute,
    private userdataservice: UserdataService,
    private navigationservice:NavigationService,
  ) {

  }

  ngOnInit(): void {
    this.activateroute.params.subscribe((params: any) => {
      this.paramsid = parseInt(params.id);
    });

    this.getdata()
    this.form = this.formBuilder.group({
      prefixed_id: [],
      status: [],
      date_created: [],
      event_end_date: [],
      event_type:[],
      duration:[],
      urgency:[],
      grade:[],
      root_cause_inflicted_by:[],
      impact:[],
      network_type:[],
      product:[],
      city:[],
      suburb:[],
    })
  }
  getdata() {
    this.userdataservice.getVumatelEventsByID(this.paramsid).subscribe((result) => {
      this.form.patchValue(result)
      this.value=result;
    })
    this.userdataservice.getUsrAffectByVumatlEvntID(this.paramsid).subscribe((result)=>{
      this.data=result;
      this.dataSource=new MatTableDataSource(this.data);
      this.dataSource.paginator=this.paginator;
      this.dataSource.sort=this.sort;
    })

  }

goback(){
  this.navigationservice.gotovumartalnetworkevents()
}
}
